import React from "react";

const UatQR1 = () => {
  return (
    <div><svg width="200" height="200" viewBox="0 0 1155 1155" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1155 0H0V1155H1155V0Z" fill="white"/>
<path d="M385 70H350V105H385V70Z" fill="black"/>
<path d="M420 70H385V105H420V70Z" fill="black"/>
<path d="M490 70H455V105H490V70Z" fill="black"/>
<path d="M525 70H490V105H525V70Z" fill="black"/>
<path d="M595 70H560V105H595V70Z" fill="black"/>
<path d="M665 70H630V105H665V70Z" fill="black"/>
<path d="M735 70H700V105H735V70Z" fill="black"/>
<path d="M385 105H350V140H385V105Z" fill="black"/>
<path d="M420 105H385V140H420V105Z" fill="black"/>
<path d="M525 105H490V140H525V105Z" fill="black"/>
<path d="M665 105H630V140H665V105Z" fill="black"/>
<path d="M735 105H700V140H735V105Z" fill="black"/>
<path d="M770 105H735V140H770V105Z" fill="black"/>
<path d="M385 140H350V175H385V140Z" fill="black"/>
<path d="M420 140H385V175H420V140Z" fill="black"/>
<path d="M455 140H420V175H455V140Z" fill="black"/>
<path d="M490 140H455V175H490V140Z" fill="black"/>
<path d="M560 140H525V175H560V140Z" fill="black"/>
<path d="M595 140H560V175H595V140Z" fill="black"/>
<path d="M630 140H595V175H630V140Z" fill="black"/>
<path d="M770 140H735V175H770V140Z" fill="black"/>
<path d="M490 175H455V210H490V175Z" fill="black"/>
<path d="M525 175H490V210H525V175Z" fill="black"/>
<path d="M560 175H525V210H560V175Z" fill="black"/>
<path d="M630 175H595V210H630V175Z" fill="black"/>
<path d="M665 175H630V210H665V175Z" fill="black"/>
<path d="M700 175H665V210H700V175Z" fill="black"/>
<path d="M735 175H700V210H735V175Z" fill="black"/>
<path d="M805 175H770V210H805V175Z" fill="black"/>
<path d="M385 210H350V245H385V210Z" fill="black"/>
<path d="M525 210H490V245H525V210Z" fill="black"/>
<path d="M560 210H525V245H560V210Z" fill="black"/>
<path d="M595 210H560V245H595V210Z" fill="black"/>
<path d="M665 210H630V245H665V210Z" fill="black"/>
<path d="M735 210H700V245H735V210Z" fill="black"/>
<path d="M770 210H735V245H770V210Z" fill="black"/>
<path d="M420 245H385V280H420V245Z" fill="black"/>
<path d="M490 245H455V280H490V245Z" fill="black"/>
<path d="M595 245H560V280H595V245Z" fill="black"/>
<path d="M805 245H770V280H805V245Z" fill="black"/>
<path d="M385 280H350V315H385V280Z" fill="black"/>
<path d="M455 280H420V315H455V280Z" fill="black"/>
<path d="M525 280H490V315H525V280Z" fill="black"/>
<path d="M595 280H560V315H595V280Z" fill="black"/>
<path d="M665 280H630V315H665V280Z" fill="black"/>
<path d="M735 280H700V315H735V280Z" fill="black"/>
<path d="M805 280H770V315H805V280Z" fill="black"/>
<path d="M420 315H385V350H420V315Z" fill="black"/>
<path d="M490 315H455V350H490V315Z" fill="black"/>
<path d="M560 315H525V350H560V315Z" fill="black"/>
<path d="M595 315H560V350H595V315Z" fill="black"/>
<path d="M630 315H595V350H630V315Z" fill="black"/>
<path d="M665 315H630V350H665V315Z" fill="black"/>
<path d="M735 315H700V350H735V315Z" fill="black"/>
<path d="M770 315H735V350H770V315Z" fill="black"/>
<path d="M105 350H70V385H105V350Z" fill="black"/>
<path d="M210 350H175V385H210V350Z" fill="black"/>
<path d="M245 350H210V385H245V350Z" fill="black"/>
<path d="M280 350H245V385H280V350Z" fill="black"/>
<path d="M315 350H280V385H315V350Z" fill="black"/>
<path d="M350 350H315V385H350V350Z" fill="black"/>
<path d="M385 350H350V385H385V350Z" fill="black"/>
<path d="M455 350H420V385H455V350Z" fill="black"/>
<path d="M490 350H455V385H490V350Z" fill="black"/>
<path d="M525 350H490V385H525V350Z" fill="black"/>
<path d="M595 350H560V385H595V350Z" fill="black"/>
<path d="M665 350H630V385H665V350Z" fill="black"/>
<path d="M700 350H665V385H700V350Z" fill="black"/>
<path d="M840 350H805V385H840V350Z" fill="black"/>
<path d="M945 350H910V385H945V350Z" fill="black"/>
<path d="M1015 350H980V385H1015V350Z" fill="black"/>
<path d="M1050 350H1015V385H1050V350Z" fill="black"/>
<path d="M1085 350H1050V385H1085V350Z" fill="black"/>
<path d="M175 385H140V420H175V385Z" fill="black"/>
<path d="M210 385H175V420H210V385Z" fill="black"/>
<path d="M245 385H210V420H245V385Z" fill="black"/>
<path d="M280 385H245V420H280V385Z" fill="black"/>
<path d="M420 385H385V420H420V385Z" fill="black"/>
<path d="M455 385H420V420H455V385Z" fill="black"/>
<path d="M560 385H525V420H560V385Z" fill="black"/>
<path d="M595 385H560V420H595V385Z" fill="black"/>
<path d="M630 385H595V420H630V385Z" fill="black"/>
<path d="M700 385H665V420H700V385Z" fill="black"/>
<path d="M735 385H700V420H735V385Z" fill="black"/>
<path d="M770 385H735V420H770V385Z" fill="black"/>
<path d="M805 385H770V420H805V385Z" fill="black"/>
<path d="M910 385H875V420H910V385Z" fill="black"/>
<path d="M945 385H910V420H945V385Z" fill="black"/>
<path d="M1015 385H980V420H1015V385Z" fill="black"/>
<path d="M1050 385H1015V420H1050V385Z" fill="black"/>
<path d="M210 420H175V455H210V420Z" fill="black"/>
<path d="M245 420H210V455H245V420Z" fill="black"/>
<path d="M280 420H245V455H280V420Z" fill="black"/>
<path d="M315 420H280V455H315V420Z" fill="black"/>
<path d="M385 420H350V455H385V420Z" fill="black"/>
<path d="M560 420H525V455H560V420Z" fill="black"/>
<path d="M630 420H595V455H630V420Z" fill="black"/>
<path d="M665 420H630V455H665V420Z" fill="black"/>
<path d="M700 420H665V455H700V420Z" fill="black"/>
<path d="M735 420H700V455H735V420Z" fill="black"/>
<path d="M840 420H805V455H840V420Z" fill="black"/>
<path d="M910 420H875V455H910V420Z" fill="black"/>
<path d="M1015 420H980V455H1015V420Z" fill="black"/>
<path d="M105 455H70V490H105V455Z" fill="black"/>
<path d="M140 455H105V490H140V455Z" fill="black"/>
<path d="M175 455H140V490H175V455Z" fill="black"/>
<path d="M210 455H175V490H210V455Z" fill="black"/>
<path d="M385 455H350V490H385V455Z" fill="black"/>
<path d="M420 455H385V490H420V455Z" fill="black"/>
<path d="M455 455H420V490H455V455Z" fill="black"/>
<path d="M490 455H455V490H490V455Z" fill="black"/>
<path d="M595 455H560V490H595V455Z" fill="black"/>
<path d="M630 455H595V490H630V455Z" fill="black"/>
<path d="M665 455H630V490H665V455Z" fill="black"/>
<path d="M700 455H665V490H700V455Z" fill="black"/>
<path d="M770 455H735V490H770V455Z" fill="black"/>
<path d="M805 455H770V490H805V455Z" fill="black"/>
<path d="M840 455H805V490H840V455Z" fill="black"/>
<path d="M875 455H840V490H875V455Z" fill="black"/>
<path d="M980 455H945V490H980V455Z" fill="black"/>
<path d="M1085 455H1050V490H1085V455Z" fill="black"/>
<path d="M315 490H280V525H315V490Z" fill="black"/>
<path d="M385 490H350V525H385V490Z" fill="black"/>
<path d="M455 490H420V525H455V490Z" fill="black"/>
<path d="M630 490H595V525H630V490Z" fill="black"/>
<path d="M665 490H630V525H665V490Z" fill="black"/>
<path d="M770 490H735V525H770V490Z" fill="black"/>
<path d="M875 490H840V525H875V490Z" fill="black"/>
<path d="M910 490H875V525H910V490Z" fill="black"/>
<path d="M1085 490H1050V525H1085V490Z" fill="black"/>
<path d="M105 525H70V560H105V525Z" fill="black"/>
<path d="M280 525H245V560H280V525Z" fill="black"/>
<path d="M350 525H315V560H350V525Z" fill="black"/>
<path d="M490 525H455V560H490V525Z" fill="black"/>
<path d="M525 525H490V560H525V525Z" fill="black"/>
<path d="M560 525H525V560H560V525Z" fill="black"/>
<path d="M595 525H560V560H595V525Z" fill="black"/>
<path d="M630 525H595V560H630V525Z" fill="black"/>
<path d="M665 525H630V560H665V525Z" fill="black"/>
<path d="M700 525H665V560H700V525Z" fill="black"/>
<path d="M735 525H700V560H735V525Z" fill="black"/>
<path d="M840 525H805V560H840V525Z" fill="black"/>
<path d="M875 525H840V560H875V525Z" fill="black"/>
<path d="M945 525H910V560H945V525Z" fill="black"/>
<path d="M980 525H945V560H980V525Z" fill="black"/>
<path d="M1015 525H980V560H1015V525Z" fill="black"/>
<path d="M1050 525H1015V560H1050V525Z" fill="black"/>
<path d="M1085 525H1050V560H1085V525Z" fill="black"/>
<path d="M105 560H70V595H105V560Z" fill="black"/>
<path d="M210 560H175V595H210V560Z" fill="black"/>
<path d="M245 560H210V595H245V560Z" fill="black"/>
<path d="M315 560H280V595H315V560Z" fill="black"/>
<path d="M350 560H315V595H350V560Z" fill="black"/>
<path d="M420 560H385V595H420V560Z" fill="black"/>
<path d="M595 560H560V595H595V560Z" fill="black"/>
<path d="M630 560H595V595H630V560Z" fill="black"/>
<path d="M665 560H630V595H665V560Z" fill="black"/>
<path d="M700 560H665V595H700V560Z" fill="black"/>
<path d="M770 560H735V595H770V560Z" fill="black"/>
<path d="M805 560H770V595H805V560Z" fill="black"/>
<path d="M840 560H805V595H840V560Z" fill="black"/>
<path d="M875 560H840V595H875V560Z" fill="black"/>
<path d="M945 560H910V595H945V560Z" fill="black"/>
<path d="M1015 560H980V595H1015V560Z" fill="black"/>
<path d="M1085 560H1050V595H1085V560Z" fill="black"/>
<path d="M105 595H70V630H105V595Z" fill="black"/>
<path d="M140 595H105V630H140V595Z" fill="black"/>
<path d="M175 595H140V630H175V595Z" fill="black"/>
<path d="M210 595H175V630H210V595Z" fill="black"/>
<path d="M385 595H350V630H385V595Z" fill="black"/>
<path d="M525 595H490V630H525V595Z" fill="black"/>
<path d="M630 595H595V630H630V595Z" fill="black"/>
<path d="M735 595H700V630H735V595Z" fill="black"/>
<path d="M875 595H840V630H875V595Z" fill="black"/>
<path d="M910 595H875V630H910V595Z" fill="black"/>
<path d="M945 595H910V630H945V595Z" fill="black"/>
<path d="M1015 595H980V630H1015V595Z" fill="black"/>
<path d="M1085 595H1050V630H1085V595Z" fill="black"/>
<path d="M105 630H70V665H105V630Z" fill="black"/>
<path d="M140 630H105V665H140V630Z" fill="black"/>
<path d="M245 630H210V665H245V630Z" fill="black"/>
<path d="M280 630H245V665H280V630Z" fill="black"/>
<path d="M315 630H280V665H315V630Z" fill="black"/>
<path d="M350 630H315V665H350V630Z" fill="black"/>
<path d="M385 630H350V665H385V630Z" fill="black"/>
<path d="M420 630H385V665H420V630Z" fill="black"/>
<path d="M455 630H420V665H455V630Z" fill="black"/>
<path d="M490 630H455V665H490V630Z" fill="black"/>
<path d="M525 630H490V665H525V630Z" fill="black"/>
<path d="M560 630H525V665H560V630Z" fill="black"/>
<path d="M805 630H770V665H805V630Z" fill="black"/>
<path d="M980 630H945V665H980V630Z" fill="black"/>
<path d="M105 665H70V700H105V665Z" fill="black"/>
<path d="M140 665H105V700H140V665Z" fill="black"/>
<path d="M175 665H140V700H175V665Z" fill="black"/>
<path d="M350 665H315V700H350V665Z" fill="black"/>
<path d="M385 665H350V700H385V665Z" fill="black"/>
<path d="M560 665H525V700H560V665Z" fill="black"/>
<path d="M630 665H595V700H630V665Z" fill="black"/>
<path d="M665 665H630V700H665V665Z" fill="black"/>
<path d="M700 665H665V700H700V665Z" fill="black"/>
<path d="M735 665H700V700H735V665Z" fill="black"/>
<path d="M770 665H735V700H770V665Z" fill="black"/>
<path d="M805 665H770V700H805V665Z" fill="black"/>
<path d="M840 665H805V700H840V665Z" fill="black"/>
<path d="M945 665H910V700H945V665Z" fill="black"/>
<path d="M1015 665H980V700H1015V665Z" fill="black"/>
<path d="M1050 665H1015V700H1050V665Z" fill="black"/>
<path d="M105 700H70V735H105V700Z" fill="black"/>
<path d="M140 700H105V735H140V700Z" fill="black"/>
<path d="M245 700H210V735H245V700Z" fill="black"/>
<path d="M280 700H245V735H280V700Z" fill="black"/>
<path d="M315 700H280V735H315V700Z" fill="black"/>
<path d="M385 700H350V735H385V700Z" fill="black"/>
<path d="M490 700H455V735H490V700Z" fill="black"/>
<path d="M525 700H490V735H525V700Z" fill="black"/>
<path d="M560 700H525V735H560V700Z" fill="black"/>
<path d="M595 700H560V735H595V700Z" fill="black"/>
<path d="M630 700H595V735H630V700Z" fill="black"/>
<path d="M665 700H630V735H665V700Z" fill="black"/>
<path d="M770 700H735V735H770V700Z" fill="black"/>
<path d="M805 700H770V735H805V700Z" fill="black"/>
<path d="M840 700H805V735H840V700Z" fill="black"/>
<path d="M875 700H840V735H875V700Z" fill="black"/>
<path d="M945 700H910V735H945V700Z" fill="black"/>
<path d="M980 700H945V735H980V700Z" fill="black"/>
<path d="M1085 700H1050V735H1085V700Z" fill="black"/>
<path d="M105 735H70V770H105V735Z" fill="black"/>
<path d="M140 735H105V770H140V735Z" fill="black"/>
<path d="M210 735H175V770H210V735Z" fill="black"/>
<path d="M245 735H210V770H245V735Z" fill="black"/>
<path d="M280 735H245V770H280V735Z" fill="black"/>
<path d="M420 735H385V770H420V735Z" fill="black"/>
<path d="M560 735H525V770H560V735Z" fill="black"/>
<path d="M630 735H595V770H630V735Z" fill="black"/>
<path d="M665 735H630V770H665V735Z" fill="black"/>
<path d="M735 735H700V770H735V735Z" fill="black"/>
<path d="M805 735H770V770H805V735Z" fill="black"/>
<path d="M945 735H910V770H945V735Z" fill="black"/>
<path d="M980 735H945V770H980V735Z" fill="black"/>
<path d="M1015 735H980V770H1015V735Z" fill="black"/>
<path d="M105 770H70V805H105V770Z" fill="black"/>
<path d="M140 770H105V805H140V770Z" fill="black"/>
<path d="M210 770H175V805H210V770Z" fill="black"/>
<path d="M280 770H245V805H280V770Z" fill="black"/>
<path d="M315 770H280V805H315V770Z" fill="black"/>
<path d="M350 770H315V805H350V770Z" fill="black"/>
<path d="M455 770H420V805H455V770Z" fill="black"/>
<path d="M490 770H455V805H490V770Z" fill="black"/>
<path d="M525 770H490V805H525V770Z" fill="black"/>
<path d="M595 770H560V805H595V770Z" fill="black"/>
<path d="M665 770H630V805H665V770Z" fill="black"/>
<path d="M700 770H665V805H700V770Z" fill="black"/>
<path d="M770 770H735V805H770V770Z" fill="black"/>
<path d="M805 770H770V805H805V770Z" fill="black"/>
<path d="M840 770H805V805H840V770Z" fill="black"/>
<path d="M875 770H840V805H875V770Z" fill="black"/>
<path d="M910 770H875V805H910V770Z" fill="black"/>
<path d="M945 770H910V805H945V770Z" fill="black"/>
<path d="M980 770H945V805H980V770Z" fill="black"/>
<path d="M1015 770H980V805H1015V770Z" fill="black"/>
<path d="M1050 770H1015V805H1050V770Z" fill="black"/>
<path d="M385 805H350V840H385V805Z" fill="black"/>
<path d="M455 805H420V840H455V805Z" fill="black"/>
<path d="M490 805H455V840H490V805Z" fill="black"/>
<path d="M525 805H490V840H525V805Z" fill="black"/>
<path d="M560 805H525V840H560V805Z" fill="black"/>
<path d="M595 805H560V840H595V805Z" fill="black"/>
<path d="M630 805H595V840H630V805Z" fill="black"/>
<path d="M735 805H700V840H735V805Z" fill="black"/>
<path d="M770 805H735V840H770V805Z" fill="black"/>
<path d="M805 805H770V840H805V805Z" fill="black"/>
<path d="M945 805H910V840H945V805Z" fill="black"/>
<path d="M980 805H945V840H980V805Z" fill="black"/>
<path d="M385 840H350V875H385V840Z" fill="black"/>
<path d="M420 840H385V875H420V840Z" fill="black"/>
<path d="M455 840H420V875H455V840Z" fill="black"/>
<path d="M525 840H490V875H525V840Z" fill="black"/>
<path d="M560 840H525V875H560V840Z" fill="black"/>
<path d="M630 840H595V875H630V840Z" fill="black"/>
<path d="M665 840H630V875H665V840Z" fill="black"/>
<path d="M700 840H665V875H700V840Z" fill="black"/>
<path d="M735 840H700V875H735V840Z" fill="black"/>
<path d="M770 840H735V875H770V840Z" fill="black"/>
<path d="M805 840H770V875H805V840Z" fill="black"/>
<path d="M875 840H840V875H875V840Z" fill="black"/>
<path d="M945 840H910V875H945V840Z" fill="black"/>
<path d="M980 840H945V875H980V840Z" fill="black"/>
<path d="M385 875H350V910H385V875Z" fill="black"/>
<path d="M420 875H385V910H420V875Z" fill="black"/>
<path d="M490 875H455V910H490V875Z" fill="black"/>
<path d="M525 875H490V910H525V875Z" fill="black"/>
<path d="M630 875H595V910H630V875Z" fill="black"/>
<path d="M700 875H665V910H700V875Z" fill="black"/>
<path d="M770 875H735V910H770V875Z" fill="black"/>
<path d="M805 875H770V910H805V875Z" fill="black"/>
<path d="M945 875H910V910H945V875Z" fill="black"/>
<path d="M385 910H350V945H385V910Z" fill="black"/>
<path d="M420 910H385V945H420V910Z" fill="black"/>
<path d="M455 910H420V945H455V910Z" fill="black"/>
<path d="M490 910H455V945H490V910Z" fill="black"/>
<path d="M560 910H525V945H560V910Z" fill="black"/>
<path d="M595 910H560V945H595V910Z" fill="black"/>
<path d="M665 910H630V945H665V910Z" fill="black"/>
<path d="M770 910H735V945H770V910Z" fill="black"/>
<path d="M805 910H770V945H805V910Z" fill="black"/>
<path d="M840 910H805V945H840V910Z" fill="black"/>
<path d="M875 910H840V945H875V910Z" fill="black"/>
<path d="M910 910H875V945H910V910Z" fill="black"/>
<path d="M945 910H910V945H945V910Z" fill="black"/>
<path d="M980 910H945V945H980V910Z" fill="black"/>
<path d="M1050 910H1015V945H1050V910Z" fill="black"/>
<path d="M385 945H350V980H385V945Z" fill="black"/>
<path d="M420 945H385V980H420V945Z" fill="black"/>
<path d="M455 945H420V980H455V945Z" fill="black"/>
<path d="M595 945H560V980H595V945Z" fill="black"/>
<path d="M630 945H595V980H630V945Z" fill="black"/>
<path d="M665 945H630V980H665V945Z" fill="black"/>
<path d="M700 945H665V980H700V945Z" fill="black"/>
<path d="M735 945H700V980H735V945Z" fill="black"/>
<path d="M1085 945H1050V980H1085V945Z" fill="black"/>
<path d="M420 980H385V1015H420V980Z" fill="black"/>
<path d="M490 980H455V1015H490V980Z" fill="black"/>
<path d="M525 980H490V1015H525V980Z" fill="black"/>
<path d="M560 980H525V1015H560V980Z" fill="black"/>
<path d="M630 980H595V1015H630V980Z" fill="black"/>
<path d="M700 980H665V1015H700V980Z" fill="black"/>
<path d="M770 980H735V1015H770V980Z" fill="black"/>
<path d="M840 980H805V1015H840V980Z" fill="black"/>
<path d="M910 980H875V1015H910V980Z" fill="black"/>
<path d="M945 980H910V1015H945V980Z" fill="black"/>
<path d="M1015 980H980V1015H1015V980Z" fill="black"/>
<path d="M1050 980H1015V1015H1050V980Z" fill="black"/>
<path d="M1085 980H1050V1015H1085V980Z" fill="black"/>
<path d="M455 1015H420V1050H455V1015Z" fill="black"/>
<path d="M560 1015H525V1050H560V1015Z" fill="black"/>
<path d="M665 1015H630V1050H665V1015Z" fill="black"/>
<path d="M735 1015H700V1050H735V1015Z" fill="black"/>
<path d="M840 1015H805V1050H840V1015Z" fill="black"/>
<path d="M910 1015H875V1050H910V1015Z" fill="black"/>
<path d="M945 1015H910V1050H945V1015Z" fill="black"/>
<path d="M980 1015H945V1050H980V1015Z" fill="black"/>
<path d="M1015 1015H980V1050H1015V1015Z" fill="black"/>
<path d="M1085 1015H1050V1050H1085V1015Z" fill="black"/>
<path d="M385 1050H350V1085H385V1050Z" fill="black"/>
<path d="M420 1050H385V1085H420V1050Z" fill="black"/>
<path d="M490 1050H455V1085H490V1050Z" fill="black"/>
<path d="M560 1050H525V1085H560V1050Z" fill="black"/>
<path d="M595 1050H560V1085H595V1050Z" fill="black"/>
<path d="M770 1050H735V1085H770V1050Z" fill="black"/>
<path d="M805 1050H770V1085H805V1050Z" fill="black"/>
<path d="M840 1050H805V1085H840V1050Z" fill="black"/>
<path d="M875 1050H840V1085H875V1050Z" fill="black"/>
<path d="M945 1050H910V1085H945V1050Z" fill="black"/>
<path d="M980 1050H945V1085H980V1050Z" fill="black"/>
<path d="M70 70V315H315V70H70ZM278.25 278.25H106.75V106.75H278.25V278.25Z" fill="black"/>
<path d="M840 70V315H1085V70H840ZM1048.25 278.25H876.75V106.75H1048.25V278.25Z" fill="black"/>
<path d="M70 840V1085H315V840H70ZM278.25 1048.25H106.75V876.75H278.25V1048.25Z" fill="black"/>
<path d="M245 140H140V245H245V140Z" fill="black"/>
<path d="M1015 140H910V245H1015V140Z" fill="black"/>
<path d="M245 910H140V1015H245V910Z" fill="black"/>
</svg>
    </div>
);
};

export default UatQR1;